import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

// Attach token from localStorage as fallback (cookies preferred)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("rwms_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  if (d?.msg) return d.msg;
  return JSON.stringify(d);
}

export const ROLES = [
  "super_admin", "managing_director", "hr_manager", "ops_coordinator",
  "accountant", "supervisor", "office_staff", "collection_staff",
];

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  managing_director: "Managing Director",
  hr_manager: "HR Manager",
  ops_coordinator: "Ops Coordinator",
  accountant: "Accountant",
  supervisor: "Supervisor",
  office_staff: "Office Staff",
  collection_staff: "Collection Staff",
};

export const SHIFTS = ["OFFICE", "COLLECTION_A", "COLLECTION_B", "COLLECTION_C"];

export function isAdminRole(role) {
  return ["super_admin", "managing_director", "hr_manager", "ops_coordinator",
          "accountant", "supervisor"].includes(role);
}

export function isStaffRole(role) {
  return ["office_staff", "collection_staff"].includes(role);
}
